<template>
    <SectionCleanLayout
        content_class="compose-messages-print"
    >
        <template #content>
            <div class="print-keep-together">
                <MessagePrintHeader
                    :message='data.message'
                    :identity='data.identity'
                />

                <MessageBody
                    :message='data.message'
                    :show_load_remote_images="false"
                    @bodyLoaded="onBodyLoaded"
                />

                <MessagePrintAttachments
                    :message='data.message'
                />
            </div>
        </template>
    </SectionCleanLayout>
</template>

<script setup>
    import {ref, onBeforeMount, onMounted} from 'vue';
    import MessagePrintAttachments         from './Partials/MessagePrintAttachments.vue';
    import MessagePrintHeader              from './Partials/MessagePrintHeader.vue';
    import MessageBody                     from './Partials/MessageBody.vue';
    import SectionCleanLayout              from '@/vue/Layouts/Sections/SectionCleanLayout.vue';
    import PopupController                 from '@/js/Webmail/PopupController';
    import DomController                   from '@/js/Webmail/DomController';

    const data    = ref();

    onBeforeMount(() => {
        setMessage();
    })

    onMounted(() => {
        DomController.setBodyClass('print-mode');
    })

    const setMessage = () => {
        data.value = PopupController.getPopupData();
    }

    const onBodyLoaded = () => {
        setTimeout(() => {
            window.print();
        }, 200);
    }
</script>